module.exports = __webpack_public_path__ + "img/empty-profile.e28c894f.svg";